import React, { useState } from 'react';
import { createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme)=> 
createStyles({
  root: {
    padding: 0,
    margin: 0,
    boxSizing: 'border-box',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(to bottom, #ffffff, #f0f0f0)',
  },
  container:{
    width: '100%',
      maxWidth: 550,
      padding: theme.spacing(3),
      background: '#fff',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
  },
  button: {
    height: '30px',
    width: '30px',
    appearance: 'none',
    backgroundColor: 'grey',
    borderRadius: '50%',
    cursor: 'pointer',
    opacity: 0,
  },
  toggleContainer: {
    display: 'flex',
    justifyContent: 'center',
    border: '3px solid black',
    borderRadius: '50px',
    margin: theme.spacing(1),
  },
  selectedButton: {
    opacity: 1,
  },
}),
);

interface IProps {
  onCompleted: (isCompleted: boolean) => void;
}

export const ThreeStateButton: React.FC<IProps> = ({onCompleted}) => {
  const classes = useStyles();
  const [selectedButton, setSelectedButton] = useState<number | null>(0);
  const colors = ['red', 'grey', 'green'];
  const handleClick = (index: number) => {
    setSelectedButton(index);
    const toggleButton = document.getElementById(`button3State-${index}`);
    if(toggleButton){
        toggleButton.style.backgroundColor = colors[index];
    }
    if(index===1){
      onCompleted(false);
    }
    else{
      onCompleted(true);
    }
  };

  React.useEffect(()=>{
    setSelectedButton(1);
  },[]);

  return (
    <div className={classes.root}>
        <div className={classes.container}>
            <Typography variant='h5'>DO NOT DISTURB</Typography>
            <div className={classes.toggleContainer}>
                {[0, 1, 2].map((index) => (
                <input
                    key={index}
                    className={`${classes.button} ${selectedButton === index ? classes.selectedButton : ''}`}
                    type="radio"
                    name="toggle"
                    id={`button3State-${index}`}
                    onClick={() => handleClick(index)}
                    checked={selectedButton === index}
                />
                ))}
            </div>
        <Typography variant='h5'>MAKE MY ROOM</Typography>
        </div>        
    </div>
  );
};
